export function isObject(value) {
  return value === Object(value);
}
